const products_on_page = document.getElementById('product-grid');
if (!products_on_page) {
  // Exit early if product grid doesn't exist
  console.warn('Product grid not found');
} else {
  let next_url = products_on_page.dataset.nextUrl;

  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  
  async function getNextPage() {
    if (!next_url) return null;
    try {
      let res = await fetch(next_url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (error) {
      console.error('Error loading next page:', error);
      return null;
    }
  }

  async function loadMoreProducts() {
    if (!load_more_btn || !load_more_spinner || !products_on_page) return;
    
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await getNextPage();

    if (!nextPage) {
      load_more_spinner.style.display = 'none';
      return;
    }

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    if (!productgrid) {
      console.warn('Product grid not found in next page');
      return;
    }
    
    const new_products = productgrid.getElementsByClassName('grid__item');
    const new_url = productgrid.dataset.nextUrl;
    
    if (new_url) {
      next_url = new_url;
      if (load_more_btn) {
        load_more_btn.style.display = 'block';
      }
    } else {
      next_url = null;
    }
    
    // Use DocumentFragment for better performance when appending multiple elements
    const fragment = document.createDocumentFragment();
    // Convert HTMLCollection to Array for better iteration performance
    Array.from(new_products).forEach((product) => {
      // Clone node from parsed document to append to live DOM
      fragment.appendChild(product.cloneNode(true));
    });
    products_on_page.appendChild(fragment);
  }
}